import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Shield, ChevronLeft } from "lucide-react";

export default function SuperAdminLogin() {
  const nav = useNavigate();
  const { setSession } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/super-login", { email, password });
      setSession(data);
      nav("/super/dashboard", { replace: true });
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-soft-indigo flex items-center justify-center p-4 relative overflow-hidden">
      <div className="blob bg-indigo-200" style={{ width: 360, height: 360, top: -40, left: -40 }} />
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="inline-flex items-center gap-1 text-stone-500 hover:text-stone-800 text-sm mb-5" data-testid="back-home-link">
          <ChevronLeft size={16} /> ホーム
        </Link>
        <div className="card-soft p-8">
          <div className="flex items-center gap-2 text-indigo-600 mb-2">
            <Shield size={18} /> <span className="font-semibold text-sm">運営者ログイン</span>
          </div>
          <h1 className="font-display text-2xl font-black text-stone-900">運営者ログイン</h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-sm font-semibold text-stone-700">メールアドレス</span>
              <input data-testid="super-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full px-3.5 py-2.5 rounded-xl border border-stone-200 bg-stone-50 focus:bg-white focus:ring-2 focus:ring-indigo-300 outline-none" />
            </label>
            <label className="block">
              <span className="text-sm font-semibold text-stone-700">パスワード</span>
              <input data-testid="super-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full px-3.5 py-2.5 rounded-xl border border-stone-200 bg-stone-50 focus:bg-white focus:ring-2 focus:ring-indigo-300 outline-none" />
            </label>
            {err && <div data-testid="super-error" className="bg-rose-50 border border-rose-200 text-rose-700 px-4 py-2.5 rounded-xl text-sm">{err}</div>}
            <button data-testid="super-submit" type="submit" disabled={loading}
              className="w-full rounded-full bg-indigo-500 hover:bg-indigo-600 disabled:opacity-50 text-white font-bold py-3.5">
              {loading ? "ログイン中..." : "ログイン"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
